import { Vue, Component, Prop } from 'vue-property-decorator';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { sessionService } from '@/providers/services/auth/session';
import ConfirmationPullup from '../m-confirmation-pull-up/m-confirmation-pull-up';
import SuccessPullupLayout from '../m-success-pull-up/m-success-pull-up';

@Component({
    name: 'm-assign-new-class',
    components: {
        'm-confirm-pull-up': ConfirmationPullup,
        'm-success-pull-up': SuccessPullupLayout,
    },
})
export default class AssignNewClassLayout extends Vue {

    // --------------------------------------------------------
    // Properties
    private isCreateShowPullup: boolean = false;

    private isConfirmationPullup: boolean = false;

    private classData: any = {};

    private isLoading: boolean = false;

    private classesList: any = [];

    @Prop()
    private isCreateConfirm: boolean = false;

    @Prop()
    private addUser: any;

    private searchQuery: string = '';

    private userData: any;
    public onSearch(searchTerm: any) {
        if (searchTerm) {
            this.classesList =  this.classesList.filter((item: any) => {
              return item.code.toLowerCase().startsWith(searchTerm.toLowerCase().trim()) ||
              item.title.toLowerCase().startsWith(searchTerm.toLowerCase().trim()) ||
              item.teacherNameDisplay.toLowerCase().startsWith(searchTerm.toLowerCase().trim());
            });
        } else {
            this.getUsersList();
        }
    }
    // ----------------------------------------------------------------
    // Hooks

    private created() {
        this.userData = this.addUser;
        this.getUsersList();
    }

    // ------------------------------------------------------------------
    // Actions
    private onAddstudent() {
        this.isCreateShowPullup = true;
    }
    private onClose(isContent: boolean = false) {
        this.$emit('onClose', isContent);
        this.$emit('addingUser');
    }
    private onNext(classData: any) {
        this.isConfirmationPullup = true;
        this.classData  = classData;
    }
    private onClosePullup() {
        this.isConfirmationPullup = false;
    }
    private onConfirm() {
        this.$emit('addingUser', this.classData);
    }
    private onDismiss() {
        this.isConfirmationPullup = false;
        this.$emit('dismissPullup');
    }
    // ------------------------------------------------------------------------
    // Methods
    private getUsersList() {
        this.isLoading = true;
        const session: any = sessionService.getSession();
        const classParam = {
            groupId: session.group_school_id,
        };
        taxonomyAPI.fetchClassesBySchool(classParam).then((classList: any) => {
            this.isLoading = false;
            this.classesList = classList || [];
        });
    }
}
